

































































































































































































































































































import { Vue, Component, Prop } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { useThemeStore } from "@/shared/store/theme";
import { Beneficiary, BeneficiaryRelationshipType, BeneficiaryStatus, BeneficiaryType } from "@/shared/types";
import UsStateSelector from "@/shared/components/UsStateSelector.vue";
import _ from "lodash";

@Component({
  components: {
    Button,
    UsStateSelector
  }
})
export default class EditBeneficiary extends Vue {
  @Prop ({ required: true })
  beneficiary: Beneficiary;

  @Prop ({ required: false })
  currentBeneficiaries: Beneficiary[];

  @Prop ({ required: true })
  onSave: () => Promise<void>;

  @Prop ()
  toggleClose: () => void;

  @Prop ()
  isNew: boolean;

  @Prop ()
  show: { value: boolean };

  @Prop ({ required: false })
  hasStatusChanged: { value: boolean };

  themeStore = useThemeStore();

  isSubmitting = false;
  needSharePercentageAdjustment = false;
  BeneficiaryRelationshipType = BeneficiaryRelationshipType;
  BeneficiaryType = BeneficiaryType;

  get isShareEditFormVisible () {
    return this.needSharePercentageAdjustment || this.hasStatusChanged;
  }

  get statusForDisplay () {
    if (!this.hasStatusChanged) {
      return "";
    }

    return this.beneficiary.status === BeneficiaryStatus.Active ? "activating" : "deactivating";
  }

  get title () {
    return this.isNew ? "Add Beneficiary"
      : this.isShareEditFormVisible
        ? "Update Beneficiary Shares"
        : "Update Beneficiary";
  }

  get submitDisabled () {
    return !this.isValid || this.isSubmitting;
  }

  get isValid () {
    return !this.$validator.errors.any();
  }

  get hasMultipleBeneficiaries () {
    return this.currentBeneficiaries.length > 0;
  }

  get primaryBeneficiaries () {
    const all = this.currentBeneficiaries.filter(b => b.type === BeneficiaryType.Primary);
    if (this.beneficiary.type === BeneficiaryType.Primary) {
      all.push(this.beneficiary);
    }

    return all;
  }

  get contingentBeneficiaries () {
    const all = this.currentBeneficiaries.filter(b => b.type === BeneficiaryType.Contingent);
    if (this.beneficiary.type === BeneficiaryType.Contingent) {
      all.push(this.beneficiary);
    }

    return all;
  }

  get totalPrimarySharePercentage () {
    return _.sumBy(this.primaryBeneficiaries, x => x.share);
  }

  get totalContingentSharePercentage () {
    return _.sumBy(this.contingentBeneficiaries, x => x.share);
  }

  get canGoBack () {
    return this.needSharePercentageAdjustment && !this.hasStatusChanged;
  }

  goBack () {
    this.needSharePercentageAdjustment = false;
  }

  isShareTotalValid (type: BeneficiaryType): boolean {
    switch (type) {
      case BeneficiaryType.Primary:
        return this.totalPrimarySharePercentage > 0 && this.totalPrimarySharePercentage !== 100;
      case BeneficiaryType.Contingent:
        return this.totalContingentSharePercentage > 0 && this.totalContingentSharePercentage !== 100;
    }
  }

  save () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      if (this.isShareTotalValid(BeneficiaryType.Primary) || this.isShareTotalValid(BeneficiaryType.Contingent)) {
        if (this.hasMultipleBeneficiaries) {
          this.needSharePercentageAdjustment = true;
        } else {
          this.errors.add({field: "share", msg: "Value must be 100 for a single beneficiary."});
        }
        return;
      }
      this.isSubmitting = true;
      this.onSave().finally(() => {
        this.isSubmitting = false;
        this.needSharePercentageAdjustment = false;
      });
    });
  }

  isInactive (status: BeneficiaryStatus): boolean {
    return status === BeneficiaryStatus.Inactive;
  }

  onClose () {
    this.needSharePercentageAdjustment = false;
    this.toggleClose();
  }
}
